import { render, staticRenderFns } from "./ga-screen.vue?vue&type=template&id=721e79f2"
import script from "./ga-screen.vue?vue&type=script&lang=ts"
export * from "./ga-screen.vue?vue&type=script&lang=ts"
import style0 from "./ga-screen.vue?vue&type=style&index=0&id=721e79f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports